import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import Tooltip from "../ToolTip/ToolTip";

import "./AmpToolTip.css";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

interface AmpToolTipProps {
    id: string;
    content: string;
    direction?: string;
    size?: SizeProp,
    textDirection?: string
}
//TODO convert FA icon to 
export default function AmpToolTip(props: AmpToolTipProps): JSX.Element {

    return (
        <>
            <Tooltip alignment={props.textDirection} content={props.content} direction={props.direction ? props.direction : "top"}>
                <FontAwesomeIcon className="tooltip" icon={faQuestionCircle} size={props.size}/>
            </Tooltip>
        </>
    )  
}